export default __webpack_public_path__ + "static/media/main3.8fdc2005.png";